const contact = {
  hero: {
    eyebrow: "Get in touch",
    title:   "We're here to help",
    sub:     "Reach out via form, phone, or your preferred messenger.",
  },
  info: {
    phoneTitle:  "Phone & Messenger",
    emailTitle:  "Email",
    socialTitle: "Social",
    hoursTitle:  "Office hours",
    hours1:      "Monday – Friday: 9:00 – 18:00",
    hours2:      "Saturday: 10:00 – 15:00",
    hours3:      "Sunday: by appointment",
  },
  form: {
    title:       "Send us a message",
    name:        "Name",
    namePh:      "Your name",
    email:       "Email",
    phone:       "Phone (optional)",
    message:     "Message",
    messagePh:   "Tell us what you're looking for...",
    submit:      "Send message",
    sending:     "Sending…",
    error:       "Something went wrong. Please try again or contact us directly.",
    successTitle:"Message sent!",
    successSub:  "We'll get back to you within 24 hours.",
  },
};

export default contact;
